/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  static #STORAGE_KEY_FOR_SECTION = 'viewedProductsForSection';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;
  static #MAX_PRODUCTS_FOR_SECTION = 10;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    let viewedProductsForSection = this.getProductsForSection();
    viewedProductsForSection = viewedProductsForSection.filter((/** @type {string} */ id) => id !== productId);
    viewedProductsForSection.unshift(productId);
    viewedProductsForSection = viewedProductsForSection.slice(0, this.#MAX_PRODUCTS_FOR_SECTION);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    localStorage.setItem(this.#STORAGE_KEY_FOR_SECTION, JSON.stringify(viewedProductsForSection));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }

  static getProductsForSection() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY_FOR_SECTION) || '[]');
  }
}
